// Tiny inline trend line, used inside table cells. No axes / legend.
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import ChartTooltip from './ChartTooltip';

interface Props {
  data: Array<{ ym: string; n: number }>;
  height?: number;
  color?: string;
  unitLabel?: string;
}

function formatYm(ym: unknown): string {
  if (typeof ym !== 'string') return String(ym ?? '');
  const m = /^(\d{4})-(\d{2})$/.exec(ym);
  if (!m) return ym;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, 1);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short' });
}

export default function Sparkline({ data, height = 28, color = 'var(--interactive-accent, #6c8cff)', unitLabel }: Props) {
  if (!data || data.length === 0) {
    return <span className="trends-sparkline-empty">—</span>;
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
        <XAxis dataKey="ym" hide />
        <YAxis hide domain={[0, 'dataMax']} />
        <Tooltip
          cursor={false}
          content={
            <ChartTooltip
              showName={false}
              labelFormatter={(label) => formatYm(label)}
              valueFormatter={(v) => (unitLabel ? `${v} ${unitLabel}` : String(v))}
            />
          }
        />
        <Line type="monotone" dataKey="n" stroke={color} strokeWidth={1.5} dot={false} isAnimationActive={false} />
      </LineChart>
    </ResponsiveContainer>
  );
}
